import { useEffect } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { hexToRgb, rgbToHex } from '~/shared';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setSelectedColor } from '../../redux/slices/colorPickerSlice';
import {
	StyledDot,
	StyledHexTextInput,
	StyledInputContainer,
	StyledRgbContainer,
	StyledRgbTextInput,
} from './ColorPickerInputs.styled';

const ColorPickerInputs = () => {
	const selectedColor = useLayoutSelector(
		(state) => state.colorPicker.selectedColor[state.colorPicker.sectionIndex],
	);
	const dispatch = useLayoutDispatch();

	useEffect(() => {
		const inputR = document.getElementById('rgbR') as HTMLInputElement | null;
		const inputG = document.getElementById('rgbG') as HTMLInputElement | null;
		const inputB = document.getElementById('rgbB') as HTMLInputElement | null;
		const inputHex = document.getElementById('hex') as HTMLInputElement | null;
		if (
			inputR === null ||
			inputG === null ||
			inputB === null ||
			inputHex === null
		) {
			return;
		}

		const activeId = document.activeElement?.id || null;
		if (activeId !== 'rgbR') inputR.value = selectedColor.r.toString();
		if (activeId !== 'rgbG') inputG.value = selectedColor.g.toString();
		if (activeId !== 'rgbB') inputB.value = selectedColor.b.toString();

		const hexColor = rgbToHex(selectedColor);
		if (activeId !== 'hex') inputHex.value = hexColor;
	}, [selectedColor]);

	const handleHexInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const textInput = event.target.value.replace(/[^a-fA-F0-9]/g, '');
		event.target.value = textInput;

		const rgbColor = hexToRgb(textInput);
		dispatch(setSelectedColor(rgbColor));
	};

	const handleRgbInputChange = (
		event: React.ChangeEvent<HTMLInputElement>,
		c: string,
	) => {
		const rgbColor = { ...selectedColor, [c]: event.target.value };
		dispatch(setSelectedColor(rgbColor));
	};

	return (
		<StyledInputContainer>
			<StyledHexTextInput
				id="hex"
				hint="#"
				onChange={handleHexInputChange}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			/>
			<StyledDot />
			<StyledRgbContainer>
				<StyledRgbTextInput
					id="rgbR"
					hint="R"
					defaultValue={selectedColor.r}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						handleRgbInputChange(e, 'r')
					}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				<StyledRgbTextInput
					id="rgbG"
					hint="G"
					defaultValue={selectedColor.g}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						handleRgbInputChange(e, 'g')
					}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				<StyledRgbTextInput
					id="rgbB"
					hint="B"
					defaultValue={selectedColor.b}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						handleRgbInputChange(e, 'b')
					}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
			</StyledRgbContainer>
		</StyledInputContainer>
	);
};

export { ColorPickerInputs };
